import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import ReportsClienteReducer from '../reportsCliente/reportsClienteReducer';
import ReportsArquivoReducer from '../reportsArquivo/reportsArquivoReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
    dashboard: DashboardReducer,
	reportsCliente: ReportsClienteReducer,
    reportsArquivo: ReportsArquivoReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;
